import { createSlice } from "@reduxjs/toolkit";
import { formattedMessages } from "../../../translations/en";
import { createIntl, type IntlShape } from "@formatjs/intl";

export interface IntlState {
  datetimeIntl: IntlShape<string>;
}

const initialState: IntlState = {
  datetimeIntl: createIntl({
    locale: "en-GB",
    messages: {
      ...formattedMessages,
    },
  }),
};

export const intlSlice = createSlice({
  name: "intl",
  initialState,
  reducers: {},
});

export const intlSliceReducer = intlSlice.reducer;
export default intlSliceReducer;
